import { Grid, IconButton, Skeleton } from '@mui/material';

import FilterDropdown from '../../../../components/filters/FilterDropdown';
import { useAppSelector } from '../../../../state/hooks';

import { FilterSkeletonText } from './ScenarioFilters.Styled';

import MetricsDropdown from '../../../../components/filters/MetricsDropdown';
import { RefreshOutlined } from '@mui/icons-material';
import { RootState } from '../../../../state/store';

interface ScenarioFilters {
  onReset: () => void;
}

export const ScenarioFilters: React.FC<ScenarioFilters> = ({ onReset }) => {
  const filtersState = useAppSelector((state: RootState) => state.filters);

  return (
    <Grid wrap="wrap" style={{ display: 'flex', flexDirection: 'column' }}>
      {filtersState.loading === true ? (
        <>
          <Grid style={{ display: 'flex', marginTop: '10px' }}>
            <Grid style={{ display: 'flex' }} item xs={12} sm={6} md={3}>
              <FilterSkeletonText>States:</FilterSkeletonText>
              <Skeleton variant="rectangular" width={100} height={25} />
            </Grid>
            <Grid style={{ display: 'flex' }} item xs={12} sm={6} md={3}>
              <FilterSkeletonText>Bottlers:</FilterSkeletonText>
              <Skeleton variant="rectangular" width={100} height={25} />
            </Grid>
            <Grid style={{ display: 'flex' }} item xs={12} sm={6} md={3}>
              <FilterSkeletonText>Categories:</FilterSkeletonText>
              <Skeleton variant="rectangular" width={100} height={25} />
            </Grid>
            <Grid style={{ display: 'flex' }} item xs={12} sm={6} md={3}>
              <FilterSkeletonText>Metrics:</FilterSkeletonText>
              <Skeleton variant="rectangular" width={100} height={25} />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid style={{ display: 'flex', marginTop: '15px', marginLeft: '1.8%' }}>
            <Grid>
              <FilterDropdown filterKey="state" label="States:" />
            </Grid>
            <Grid style={{ marginLeft: '8px' }}>
              <FilterDropdown filterKey="bottler" label="Bottlers:" />
            </Grid>
            <Grid style={{ marginLeft: '8px' }}>
              <FilterDropdown filterKey="category" label="Categories:" singleSelect />
            </Grid>
            <Grid style={{ marginLeft: '8px', marginRight: '0' }}>
              <MetricsDropdown />
            </Grid>
            <Grid>
              <IconButton style={{ padding: 0 }} onClick={onReset}>
                <RefreshOutlined
                  style={{
                    color: 'red',
                    fontSize: '15px',
                    padding: '0px',
                    // marginLeft: '5px',
                    cursor: 'pointer',
                  }}
                ></RefreshOutlined>
              </IconButton>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
